<template>
  <div>
    <div class="main-router">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item v-for="(item,index) in list" :key="index" v-if="item.path" :to="{ path: item.path }">{{item.name}}</el-breadcrumb-item>
        <el-breadcrumb-item v-else :to="false">{{item.name}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="main-block">
      <div class="big-title-box flex-row-center">
        <div class="line"></div>
        <h1 class="big-title">鉴证书查询</h1>
      </div>
      <h3 class="title">百色市农村产权交易中心交易鉴证书查询</h3>
      <el-form :model="formData" label-width="80px" inline label-position="left">
        <el-form-item label="手机号：">
          <el-input maxlength="11" v-model="formData.phone" type="text" placeholder="请输入" clearable=""></el-input>
        </el-form-item>
        <el-form-item label="验证码：">
          <el-input maxlength="6" v-model="formData.captcha"  type="text" placeholder="请输入" clearable=""></el-input>
        </el-form-item>
        <el-button class="get-code" @click="!isGet && getCountdown()">{{countdown}}</el-button>
        <el-button class="search-btn" type="primary" @click="doSearch">查询</el-button>
      </el-form>
      <p class="result">查询结果：</p>
      <el-table
          v-loading="dataListLoading"
          :data="dataList"
          :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{ 'text-align': 'center' }"
          border="">
        <el-table-column label="证书类型">
          <template slot-scope="scope">{{
              scope.row.type == 1
                  ? "交易鉴证书"
                  : scope.row.type == 2
                  ? "解押通知书"
                  : scope.row.type == 3
                      ? "贷款还清证明"
                      : "--"
            }}</template>
        </el-table-column>
        <el-table-column prop="name" label="标的名称"></el-table-column>
        <el-table-column prop="businessTypeDesc" label="业务类型"></el-table-column>
        <el-table-column prop="provideTime" label="证书上传时间"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
                <span
                    class="blueC"
                    @click="scope.row.certificateUrl && detailUrl(scope.row)"
                >{{ scope.row.certificateUrl ? "查看" : "--" }}</span
                >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
          background
          style="text-align: center;margin-top: 56px;"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next,jumper"
          :total="total"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import publicFun from "@/utils/publicFunction";
import {sessionStore} from "@/utils/data-management";

export default {
  data(){
    return {
      curPage: 1,
      pageSize: 10,
      total: 0,
      countdown: "获取验证码",
      isGet: false,
      formData: {
        phone: '',
        captcha: ''
      },
      dataListLoading: false,
      dataList: [],
      list: [
        {
          name:'首页',
          path: '/Home'
        },
        {
          name:'鉴证书查询'
        }
      ]
    }
  },
  mounted() {
    if(sessionStore.get('searchPhone')){
      this.$set(this.formData,'phone',sessionStore.get('searchPhone'))
      this.getDataList()
    }
  },
  beforeRouteLeave(to,from,next){
    if(to.name!='myCertificateDetail'){
      sessionStore.remove('searchPhone')
    }
    next()
  },
  methods: {
    handleSizeChange(val){
      if(this.formData.phone!=sessionStore.get('searchPhone')){
        return this.$message.error('请输入验证码校验后再查询')
      }
      this.pageSize = val
      this.getDataList()
    },
    handleCurrentChange(val){
      if(this.formData.phone!=sessionStore.get('searchPhone')){
        return this.$message.error('请输入验证码校验后再查询')
      }
      this.curPage = val
      this.getDataList()
    },
    detailUrl(row) {
      sessionStore.set("CertificateDetail", row);
      this.$router.push({ name: "myCertificateDetail" });
    },
    async doSearch(){
      if (!publicFun.isPhone(this.formData.phone)) {
        return this.$message.error("请输入正确的手机号");
      }
      if(!this.formData.captcha){
        return this.$message.error("请输入验证码");
      }
      const isOk = await this.validCode()
      if(!isOk) return
      sessionStore.set("searchPhone", this.formData.phone)
      this.getDataList()
    },
    //验证验证码
    validCode(){
      return new Promise((resolve)=>{
        this.$api.sign.validForgetPassword({
          mobile: this.formData.phone,
          code: this.formData.captcha
        }).then(res=>{
          if(res.code===1000){
            resolve(true)
          }else {
            resolve(false)
          }
        }).catch(()=>{
          resolve(false)
        })
      })
    },
    getDataList(){
      this.dataListLoading = true
      this.$api.user.pageCertificate({
        phone: this.formData.phone,
        pageSize: this.pageSize,
        startRow: (this.curPage-1)*this.pageSize
      }).then(res=>{
        if(res.code===1000){
          this.dataList = res.data
          this.total = res.total
        }
      }).finally(()=>{
        this.dataListLoading = false
      })
    },
    // 获取验证码
    getCountdown() {
      if (!publicFun.isPhone(this.formData.phone)) {
        return this.$message.error("请输入正确的手机号");
      }
      if (this.countdown != "获取验证码") return;
      this.isGet = true
      let countdown = 60;
      this.$api.sign.forgetMessage({ mobile: this.formData.phone }).then(res => {
        if(res.code == 1000){
          this.$message.success('验证码已发送')
          this.timer = window.setInterval(() => {
            if (countdown == 0) {
              this.countdown = "获取验证码";
              clearInterval(this.timer);
              this.isGet = false
            } else {
              this.countdown = `${countdown}秒`;
              countdown--;
            }
          }, 1000);
        }
      }).catch((error) => {
        this.isGet = false
      }).finally(() => {
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.main-router{
  padding: 20px 0;
  max-width: 1200px;
  margin: 0  auto;
  background: transparent;
}
.big-title-box{
  border-bottom: 1px solid #eee;
  padding-bottom: 25px;
  margin-bottom: 30px;
  .line{
    width: 4px;
    height: 20px;
    background: #F65248;
    margin-right: 8px;
  }
  .big-title{
    font-size: 20px;
    font-weight: 600;
    color: #F65248;
    line-height: 20px;
    height: 20px;
    margin: 0;
  }
}
.title{
  font-size: 24px;
  font-weight: 600;
  color: #394259;
  line-height: 24px;
  margin-bottom: 30px;
  text-align: center;
}
.get-code{
  width: 119px;
  color: #F65248;
  border: 1px solid #F65248;
}
.search-btn{
  width: 119px;
  float: right;
}
.result{
  font-size: 16px;
  font-weight: 600;
  color: #394259;
  line-height: 14px;
  margin-top: 8px;
  margin-bottom: 20px;
}
</style>
